import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export interface PieChartProps {
  labels: string[];
  data: number[];
  title?: string;
  className?: string;
  colors?: string[];
  height?: number;
  width?: number;
}

const DEFAULT_COLORS = [
  "#4f46e5", // indigo
  "#0891b2", // cyan
  "#16a34a", // green
  "#ca8a04", // yellow
  "#dc2626", // red
  "#7c3aed", // purple
  "#ea580c", // orange
  "#0d9488", // teal
  "#db2777", // pink
  "#2563eb", // blue
];

export const PieChart = ({
  labels,
  data,
  title,
  className = "",
  colors,
  height = 300,
  width = 300,
}: PieChartProps) => {
  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors || DEFAULT_COLORS.slice(0, labels.length),
        borderColor: "#ffffff",
        borderWidth: 2,
        hoverOffset: 8,
      },
    ],
  };

  const options: ChartOptions<"pie"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#64748b",
          font: {
            size: 12,
            weight: "normal",
          },
          padding: 16,
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      title: {
        display: !!title,
        text: title,
        color: "#0f172a",
        font: {
          size: 16,
          weight: "bold",
        },
        padding: {
          bottom: 16,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) : 0;
            return `${context.label}: ${context.parsed} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div className={className} style={{ height, width: "100%" }}>
      <Pie data={chartData} options={options} />
    </div>
  );
};
